import { Box, CircularProgress, Typography, Fade } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const Loader = ({ message = "Loading..." }) => {
  const theme = useTheme();
  
  return (
    <Fade in={true}>
      <Box
        sx={{
          position: "fixed",
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(10px)",
          zIndex: 9999,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 3,
            p: 4,
            borderRadius: theme.shape.borderRadiusMd,
            backgroundColor: "white",
            boxShadow: theme.customShadows.z16,
            border: `1px solid ${theme.palette.grey[200]}`,
          }}
        >
          <CircularProgress 
            size={60} 
            thickness={4}
            sx={{
              color: theme.palette.primary.main,
              '& .MuiCircularProgress-circle': {
                strokeLinecap: 'round',
              }
            }}
          />
          <Typography 
            variant="h6" 
            sx={{ 
              color: "text.primary",
              fontWeight: 600,
              textAlign: "center"
            }}
          >
            {message}
          </Typography>
        </Box>
      </Box>
    </Fade>
  );
};
